// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","logoContainer":"Header_logoContainer__Ca1SE"};